import { httpClient } from '../httpClient';

export const scimApi = {
  listTokens: () =>
    httpClient.get('/settings/scim/tokens'),

  createToken: (name) =>
    httpClient.post('/settings/scim/tokens', { name }),

  revokeToken: (id) =>
    httpClient.delete(`/settings/scim/tokens/${id}`),

  // M-FE-11 — IdP config landing surface
  getIdentityProviders: () =>
    httpClient.get('/settings/scim/identity-providers'),
};
